var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_vm._l((_vm.completed),function(index){return _c('span',{key:`enem-weight-${index}`,class:`level-bar bg-${_vm.type}`})}),_vm._v(" "),_vm._l((10 - _vm.completed),function(index){return _c('span',{key:index,staticClass:"level-bar bg-gray-dark"})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }